import React, { useState } from "react";
import "./add-risklevel.modal.scoped.scss";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import { Box, Button, TextField, Typography } from "@material-ui/core";
import { slugRegex } from "../../../../statics/validators";
import { showToastMsg } from "../../../../helpers";
import { iconOptions } from "../../types/iconOptions";
import { IconOption } from "../../../../types/iconOption";
import { RiskLevelsService } from "../../../../services/riskLevels.services";

const AddRiskLevelModal = (props: any) => {
  const { t } = useTranslation();
  const handleClose = (value: any) => props.onClose(value);
  const { riskLevel, editable } = props;
  const riskLevelsService: RiskLevelsService = new RiskLevelsService();

  const [slugError, setSlugError] = useState(false);
  const [saving, setSaving] = useState(false);

  console.log(riskLevel);
  const [formData, setFormData] = useState({
    iconKey: editable ? riskLevel.iconKey : "",
    nameEN: editable ? riskLevel.name_en : "",
    nameDE: editable ? riskLevel.name_de : "",
    slug: editable ? riskLevel.slug : "",
  });

  const isFormValid = Object.values(formData).every(
    (value) => value.trim() !== "",
  );

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "slug" ? value.toLocaleUpperCase() : value,
    }));
  };

  const submit = async () => {
    setSaving(true);
    const response = editable
      ? await riskLevelsService.update(riskLevel.id, formData)
      : await riskLevelsService.create(formData);
    if (response && response.message === "SUCCESS") {
      showToastMsg(
        "success",
        editable
          ? t(
              "SETTINGS_PAGES.RISK_LEVEL_MANAGEMENT.RISK_LEVEL_UPDATED_SUCCESSFULLY",
            )
          : t(
              "SETTINGS_PAGES.RISK_LEVEL_MANAGEMENT.RISK_LEVEL_ADDED_SUCCESSFULLY",
            ),
      );
      handleClose(true);
    }
    setSaving(false);
  };

  const copyIcon = (key: string) => {
    navigator.clipboard
      .writeText(key)
      .then(() => {
        showToastMsg("success", t("ICON_KEY_COPIED_SUCCESSFULLY"));
      })
      .catch((err) => {
        console.error("Failed to copy text!");
      });
  };

  return (
    <Modal
      show={props.show}
      onHide={handleClose.bind(null, false)}
      centered
      dialogClassName={
        props.dialogClassName ? props.dialogClassName : "modal-xl"
      }
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <Box className="add__risklevel_form">
          <Box className="global__box__content p-0">
            <Box className="title">
              <Typography variant="subtitle1" style={{ fontWeight: 400 }}>
                {editable
                  ? t(
                      "SETTINGS_PAGES.RISK_LEVEL_MANAGEMENT.UPDATE_A_RISK_LEVEL",
                    )
                  : t(
                      "SETTINGS_PAGES.RISK_LEVEL_MANAGEMENT.CREATE_A_NEW_RISK_LEVEL",
                    )}
              </Typography>
            </Box>
            <Box className="content">
              <Box className="row-col-2">
                <Typography variant="subtitle2">{t("ICON")}</Typography>
                <Box className="standard_text_input">
                  <TextField
                    className="w-100"
                    variant="standard"
                    name="iconKey"
                    value={formData.iconKey || ""}
                    onChange={handleChange}
                    inputProps={{
                      maxLength: 30,
                    }}
                  />
                </Box>
              </Box>
              <Box className="row-col-2">
                <Typography variant="subtitle2">
                  {t("SETTINGS_PAGES.RISK_LEVEL_MANAGEMENT.RISK_LEVEL_NAME_EN")}
                </Typography>
                <Box className="standard_text_input">
                  <TextField
                    className="w-100"
                    variant="standard"
                    name="nameEN"
                    value={formData.nameEN || ""}
                    onChange={handleChange}
                    inputProps={{
                      maxLength: 30,
                    }}
                  />
                </Box>
              </Box>
              <Box className="row-col-2">
                <Typography variant="subtitle2">
                  {t("SETTINGS_PAGES.RISK_LEVEL_MANAGEMENT.RISK_LEVEL_NAME_DE")}
                </Typography>
                <Box className="standard_text_input">
                  <TextField
                    className="w-100"
                    variant="standard"
                    name="nameDE"
                    value={formData.nameDE || ""}
                    onChange={handleChange}
                    inputProps={{
                      maxLength: 30,
                    }}
                  />
                </Box>
              </Box>
              <Box className="row-col-2">
                <Typography variant="subtitle2">
                  {t("SETTINGS_PAGES.RISK_LEVEL_MANAGEMENT.SLUG")}
                </Typography>
                <Box className="standard_text_input">
                  <TextField
                    className="w-100"
                    variant="standard"
                    name="slug"
                    value={formData.slug || ""}
                    onChange={(e) => {
                      handleChange(e);
                      e.target.value
                        ? setSlugError(
                            !slugRegex.test(e.target.value.toLocaleUpperCase()),
                          )
                        : setSlugError(false);
                    }}
                    disabled={editable}
                    error={slugError ? true : false}
                    inputProps={{
                      maxLength: 30,
                    }}
                  />
                  {slugError && (
                    <p className="error-msg">
                      It should be only letters, underscore and numbers
                    </p>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
          <Box className="global__box__content p-0">
            <Box className="title">
              <Typography variant="subtitle1" style={{ fontWeight: 400 }}>
                {t("SETTINGS_PAGES.RISK_LEVEL_MANAGEMENT.SET_OF_ICONS")}
              </Typography>
            </Box>
            <Box className="icons">
              <Box className="items">
                {iconOptions[3].icons.map((icon: IconOption, i: number) => {
                  return (
                    <Box
                      key={i}
                      className="box-icon"
                      onClick={() => copyIcon(icon.key)}
                    >
                      <img src={icon.path} alt="" />
                      {icon.name}
                      <span className="overlay"></span>
                      <span className="copy">{t("COPY")}</span>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outlined"
          color="primary"
          className="btn-secondary-theme"
          onClick={handleClose.bind(null, false)}
        >
          {t("cancel")}
        </Button>
        <Button
          disabled={!isFormValid || saving || Boolean(slugError)}
          onClick={submit}
          className="btn-primary-theme"
          variant="contained"
          color="primary"
        >
          {editable
            ? t("SETTINGS_PAGES.RISK_LEVEL_MANAGEMENT.UPDATE_RISK_LEVEL")
            : t("SETTINGS_PAGES.RISK_LEVEL_MANAGEMENT.CREATE_NEW_RISK_LEVEL")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddRiskLevelModal;
